export const VAvatarConfig = {
  rounded: 1,
};
